import { ReactComponent as Logo } from '../../assets/svg/CitrusLink-2020.svg';
import { makeStyles } from '@material-ui/core';

export const LoginHeader = () => {
  const classes = useStyles();
  return (
    <div className={classes.header}>
      <div className={classes.logo}>
        <Logo />
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: any) => ({
  header: {
    backgroundColor: theme.palette.paper.dark,
    width: '100%',
    padding: 15,
  },
  logo: {
    width: 200,
    height: 'auto',
  },
}));
